import { useContext, useEffect, useReducer, useState } from 'react';

import { Filters } from '../../components/CommonInputs';
import { FRPSearchResults } from './FRPSearchResults';
import { ActiveFilters } from '../../compentsModus/ActiveFilters';
import { ExploreSearchActions, ExploreSearchContext, ExploreSearchReducer, ExploreSearchState, FilterType, GenericTransactionManager, MessageType, transactionalExploreSearchReducer } from '../../states/ExploreSearchState';
import { ProtectedFeature } from 'src/components/ProtectedFeature';
import { actionSetInfoMessage, AppMessagesContext, Localization } from '@viamap/viamap2-common';
import { AddressInterface } from 'src/managers/AddressInterface';
import { ProjectContext, handleToBeAdded } from 'src/states/ProjectState';
import { Feature } from 'src/states/ApplicationStateFeatures';
import { ViewButtonText } from 'src/propertyInfoTemplates/PropertyComponents';
import { ADModalBodyNoScroll, AdvancedDragModal } from 'src/componentsUtils/AdvancedDragModal';
import { useWindowContext } from 'src/WindowManager/useWindowContext';
import { closeWindow, ManagedWindow, WindowId } from 'src/WindowManager/WindowState';
import { MitStorage } from 'src/managers/MitStorage';

export const FRPSearchWindow = (props: { managedWindow: ManagedWindow, callbackOnClose: () => void }) => {

  function initialFRPExploreSearchState(): ExploreSearchState {

    return {
      activeTransactions: {},
      message: "",
      messageType: MessageType.Success,
      favoriteSearchesStorageKey: "FRPFilterFavoritSearch",
      searchStorageKey: "FRPFilterSearch",
      favoritFilters: (MitStorage.getValue("FRPFilterFavoritSearch") || []),
      activeFilters: (MitStorage.getValue("FRPFilterSearch") || {}),
      selectableFilterList: {
        "type": {
          title: "Record Type", filterType: FilterType.SelectText, default: ["Element"],
          translationTable: { "en": { "Record Type": "Record Type" }, "da": { "Record Type": "Record Type" } },
          options: {
            "Element": "Element",
            "Action": "Action",
            "Message": "Message"
          },
        },
        "lastChangedUser": {
          title: "Last Changed By", filterType: FilterType.String, default: [""],
          translationTable: { "en": { "Last Changed By": "Last Changed By" }, "da": { "Last Changed By": "Senest ændret af" } }
        },
        "elementId": {
          title: "Element ID", filterType: FilterType.String, default: [""],
          translationTable: { "en": { "Element ID": "Element ID" }, "da": { "Element ID": "Element ID" } }
        },
        "lastChangedTimestamp": {
          title: "Last Changed Date", filterType: FilterType.DateRange, default: ["2000-01-01", (new Date).toISOString().split("T")[0]],
          translationTable: { "en": { "Last Changed Date": "Last Changed Date" }, "da": { "Last Changed Date": "Seneste ændringsdato" } }
        },
        "expectedStartDate": {
          title: "Expected Start Date", filterType: FilterType.DateRange, default: ["2000-01-01", (new Date).toISOString().split("T")[0]],
          translationTable: { "en": { "Expected Start Date": "Expected Start Date" }, "da": { "Expected Start Date": "Forventet startdato" } }
        },
        "expectedEndDate": {
          title: "Expected End Date", filterType: FilterType.DateRange, default: ["2000-01-01", (new Date).toISOString().split("T")[0]],
          translationTable: { "en": { "Expected End Date": "Expected End Date" }, "da": { "Expected End Date": "Forventet slutdato" } }
        },
        "drawn_area": {
          hideOnFilterList: true, title: "Bounding box", filterType: FilterType.BoundingBox, default: [11.635048941530158, 55.074257075021336, 12.362662349049884, 55.425561915849045],
          translationTable: { "en": { "Bounding box": "Bounding box" }, "da": { "Bounding box": "Tegnet boks" } }
        },
        "polygon": {
          index_field_override: "geopoint", hideOnFilterList: true, title: "Drawn Area", filterType: FilterType.Polygon, default: [
            [
              [
                55,
                10
              ],
              [
                10,
                10
              ],
              [
                10,
                55
              ],
              [
                55,
                55
              ],
              [
                55,
                10
              ]
            ]
          ],
          translationTable: { "en": { "Drawn Area": "Drawn Area" }, "da": { "Drawn Area": "Tegnet område" } }
        },
        "bfe_nr_set": { hideOnFilterList: true, index_field_override: "bfe_nr", title: "bfe set", filterType: FilterType.IntegerSet, default: [], translationTable: {} }
      }
    };
  }

  const [state, dispatch] = useReducer(ExploreSearchReducer, initialFRPExploreSearchState());
  const [viewInfoBox, setViewInfoBox] = useState(0)
  const [coords, setViewCoords] = useState<[number, number]>([0, 0])
  const [latLng, setLatLng] = useState<{ lat: number, lng: number }>({ lat: 0, lng: 0 })
  const { dispatch: WindowDispatch } = useWindowContext();

  const { state: projState, dispatch: projDispatch } = useContext(ProjectContext)
  const { dispatch: appMsgDispatch } = useContext(AppMessagesContext)

  // const { state, dispatch } = useContext(ExploreSearchContext);

  function bfeHandler(a, b) {
    setViewInfoBox(a);
    setViewCoords(b);
  }

  useEffect(() => {
    //Refreshes PropertyInfo
    setLatLng({ lat: coords[1], lng: coords[0] })
  }, [coords])

  return (
    <ExploreSearchContext.Provider value={{ state: state, dispatch: GenericTransactionManager.dispatchMiddleware<ExploreSearchActions>(dispatch, transactionalExploreSearchReducer) }}>
      <AdvancedDragModal
        window={props.managedWindow}
        PosDefault={{ left: "200px", top: "50%", transform: "translateY(-50%)", height: "800px", width: "1000px" }}
        PosDefaultNS={{ width: "calc( 100% - 30px )", height: "calc(100% - 50px)", top: "50px", left: "15px" }}
        saveKey="FRPSearchWindow"
        title={"FRP Search"}
        allowUserMiniMize
        allowFullscreen
        onClose={() => WindowDispatch(closeWindow(WindowId.FRPSearch))}
        subHeaderContent={viewInfoBox ?
          <ProtectedFeature feature={Feature.AddToProjectUnassignedList} contentsIfNoAccess={<></>} >
            <ViewButtonText onClick={async () => {
              if (projState.isEmpty) {
                appMsgDispatch(actionSetInfoMessage(Localization.getText("Please visit the Project tabs, an action is needed!")))
                return
              }
              if (latLng?.lat && latLng?.lng) {

                let resp = await AddressInterface.reverseGeocodeFull(latLng.lat, latLng.lng);
                let addrData = await resp.json();
                let jordstykke = await (await fetch(addrData.jordstykke.href)).json()

                let fullAddress = addrData.adressebetegnelse;
                let tmp = fullAddress.split(',');
                let streetAndNumber = tmp[0] || fullAddress;
                let zipAndCity = addrData.postnummer.nr + " " + addrData.postnummer.navn;

                projDispatch(handleToBeAdded([{ bfeNr: jordstykke.bfenummer, name: streetAndNumber + ", " + zipAndCity, latLng: [latLng.lat, latLng.lng] }]))
                return
              }
            }}
            >
              {Localization.getText("Add to Project")}
            </ViewButtonText>
          </ProtectedFeature>
          : null}
      >
        <ADModalBodyNoScroll
          templateRows={
            !viewInfoBox ?
              "minmax(300px, 20%) 1fr" :
              "50% 50%"
          }
        >

          {!viewInfoBox ? <>
            <Filters />
          </> : null}
          <div className='glassColumn'>
            <ActiveFilters />
            <FRPSearchResults selectBFECallback={(a, b) => bfeHandler(a, b)} callBackOnClose={() => setViewInfoBox(0)} showClose={Boolean(viewInfoBox)} />
          </div>
        </ADModalBodyNoScroll>
      </AdvancedDragModal>
    </ExploreSearchContext.Provider>
  );
}



